import React from "react";
import "./hero.css";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <div className="hero" id="home">
      <div className="hero_left">
        <h1>Are you Feeling down or depressed?</h1>
        <p>
          Get to communicate with people who are going through similar problems
          as yours and help yourselves heal together.
        </p>{" "}
        <Link to="/start">
          {" "}
          <button>Get Started</button>
        </Link>
      </div>
      <div className="hero_right"></div>
    </div>
  );
};

export default Hero;
